function toMillis(value) {
  if (!value) return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.toDate === "function") return value.toDate().getTime();
  if (typeof value?.seconds === "number") return value.seconds * 1000;
  const parsed = Date.parse(String(value));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getSessionRecencyTimestamp(session = {}) {
  return (
    toMillis(session.lastMessageAt) ||
    toMillis(session.updatedAt) ||
    toMillis(session.createdAt || session.startedAt || session.date || session.dateISO)
  );
}

export function getSessionConversationRecencyTimestamp(session = {}) {
  const messageTimestamp = (Array.isArray(session.messages)
    ? session.messages
    : []
  ).reduce((latest, message) => Math.max(
    latest,
    toMillis(
      message?.createdAt ||
      message?.sentAt ||
      message?.timestamp ||
      message?.updatedAt
    )
  ), 0);
  return Math.max(
    toMillis(session.lastMessageAt),
    messageTimestamp,
    toMillis(session.completionVersion?.completedAt),
    toMillis(session.endedAt),
    toMillis(session.startedAt),
    toMillis(session.createdAt || session.date || session.dateISO)
  );
}

export function getSessionSortFieldUsed(session = {}) {
  if (toMillis(session.lastMessageAt)) return "lastMessageAt";
  if (toMillis(session.updatedAt)) return "updatedAt";
  return "createdAt";
}

export function sortSessionsByRecency(sessions = []) {
  return [...sessions].sort((a, b) => getSessionRecencyTimestamp(b) - getSessionRecencyTimestamp(a));
}

export function firstUserMessageMetadata(session = {}) {
  const firstUser = (Array.isArray(session.messages) ? session.messages : []).find((message) => message?.role !== "assistant");
  const text = String(firstUser?.content || "");
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) {
    hash = ((hash << 5) - hash + text.charCodeAt(index)) | 0;
  }
  return {
    firstUserMessageLength: text.length,
    firstUserMessageHash: text ? String(hash >>> 0) : "",
  };
}

export function logSessionListDiagnostics(listName, sessions = [], source = "unknown") {
  try {
    console.info("[sessions] sessionListSource", {
      dashboardListName: listName,
      sessionListSource: source,
      count: Array.isArray(sessions) ? sessions.length : 0,
    });
    sortSessionsByRecency(Array.isArray(sessions) ? sessions : []).slice(0, 25).forEach((session) => {
      console.info("[sessions] sessionListItem", {
        dashboardListName: listName,
        sessionId: String(session?.id || ""),
        createdAt: toMillis(session?.createdAt || session?.startedAt || session?.date || session?.dateISO),
        updatedAt: toMillis(session?.updatedAt),
        lastMessageAt: toMillis(session?.lastMessageAt),
        messageCount: Number(session?.messageCount || (Array.isArray(session?.messages) ? session.messages.length : 0) || 0),
        sessionSummaryCreatedAt: toMillis(session?.sessionSummary?.generatedAt || session?.sessionSummary?.createdAt),
        sortFieldUsed: getSessionSortFieldUsed(session),
        ...firstUserMessageMetadata(session),
      });
    });
  } catch {}
}
